module.exports = __webpack_public_path__ + "static/media/MySQL.9a87849c.svg";